import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import type { UserListFilterState } from './model/userListFilter';
import type { UserListColumnId } from './types';
import UsersFilter from './UsersToolBar/UsersFilter';

interface UsersToolBarProps {
    setShowUserCard: (userId: number | false) => void;
    showRole: boolean;
    showTeam: boolean;
    showAdmin: boolean;
    onToggleColumn: (id: UserListColumnId) => void;
    onRefresh: () => void;
    onReset: () => void;
    filter: UserListFilterState;
    onApplyFilter: (filter: UserListFilterState) => void;
}

const UsersToolBar = ({
    setShowUserCard,
    showRole,
    showTeam,
    showAdmin,
    onToggleColumn,
    onRefresh,
    onReset,
    filter,
    onApplyFilter,
}: UsersToolBarProps) => {
    const { t } = useTranslation();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                <Button
                    className="fs-14"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        setShowUserCard(-1);
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('Users.toolBarAdd')}</span>
                </Button>

                <ListToolBarActions
                    onRefresh={onRefresh}
                    onReset={onReset}
                    columns={{
                        items: [
                            { id: 'role', label: t('Users.theadRole'), visible: showRole },
                            { id: 'team', label: t('Users.theadTeam'), visible: showTeam },
                            { id: 'admin', label: t('Users.theadAdmin'), visible: showAdmin },
                        ],
                        onToggle: (id) => onToggleColumn(id as UserListColumnId),
                    }}
                />

                <UsersFilter filter={filter} onApply={onApplyFilter} />
            </div>
        </div>
    );
};

export default UsersToolBar;
